import { FormattedMessage } from "react-intl";
import { Link } from "react-router";

export function DocumentDeleteConflictAlert({ id, sharedItemIds }: { id?: string; sharedItemIds: readonly string[] }) {
  return (
    <div id={id} className="mt-3 text-smycles-label text-red-600" role="alert">
      <FormattedMessage
        id="service.page.documentDeleteBlocked"
        defaultMessage="This document is still used in shared posts. Remove it there first:"
      />
      <SharedItemLinks id={id} className="mt-1" sharedItemIds={sharedItemIds} />
    </div>
  );
}

export function SharedItemLinks({ id, sharedItemIds, className = "" }: { id?: string; sharedItemIds: readonly string[]; className?: string }) {
  return (
    <ul className={`flex flex-wrap gap-x-3 gap-y-1 ${className}`}>
      {sharedItemIds.map((sharedItemId, index) => (
        <li key={sharedItemId}>
          <Link
            id={id && `${id}-item-${sharedItemId}`}
            className="font-medium underline underline-offset-2 hover:text-red-800"
            to={`/share/discover/${sharedItemId}`}
          >
            <FormattedMessage
              id="service.page.openBlockingSharedItem"
              defaultMessage="Open shared post {number}"
              values={{ number: index + 1 }}
            />
          </Link>
        </li>
      ))}
    </ul>
  );
}
